import {gql} from '@apollo/client';
import {AppealTicketStatus} from './getAppealTicketPageList';

/**
 * 罚单申诉审核详情，对应 api-server `PartnerControlAppealReviewQuery.getAppealTicketDetail`。
 */

export interface AppealTicketDspType {
    id?: number | null;
    name?: string | null;
    dspCode?: string | null;
    contactPhone?: string | null;
}

export interface AppealOperationLogType {
    id: number;
    operatorName?: string | null;
    /** ISO-8601 字符串 */
    operatedAt?: string | null;
    description?: string | null;
}

/** 一次申诉提交的详情，对应一组（一个申诉次数） */
export interface AppealDetailType {
    appealCount?: number | null;
    appealReason?: string | null;
    /** ISO-8601 字符串 */
    appealTime?: string | null;
    evidenceImageUrls: string[];
}

export interface AppealTicketDetailType {
    id: number;
    ticketNo: string;
    trackingNumber?: string | null;
    /**
     * 运单对应的订单 ID，按 GraphQL Long 标量惯例序列化成字符串（避免 JS 精度丢失）。
     * 为空表示查不到对应订单（如 partner_penalty 尚未存 order_id），此时运单号不可点击查详情。
     */
    orderId?: string | null;
    reason?: string | null;
    source?: string | null;
    amount?: number | null;
    /** ISO-8601 字符串 */
    creationTime?: string | null;
    /** ISO-8601 字符串 */
    appealTime?: string | null;
    /** ISO-8601 字符串；按罚单生成时间 + 48 小时推算展示，非独立存储字段 */
    appealDeadline?: string | null;
    driverName?: string | null;
    driverPhone?: number | null;
    rejectReason?: string | null;
    hubName?: string | null;
    warehouseName?: string | null;
    status: AppealTicketStatus;
    statusDescription?: string | null;
    /** 罚单原始状态编码（如 REVIEWING/APPROVED/TIMEOUT），用于国际化展示；未知状态时为空 */
    penaltyStatusCode?: string | null;
    /** 申诉记录列表，按申诉次数倒序（最新一次在前）；尚无申诉记录时为空列表 */
    appealDetails: AppealDetailType[];
    dsp?: AppealTicketDspType | null;
    operationLogs: AppealOperationLogType[];
}

export const GET_APPEAL_TICKET_DETAIL = gql`
    query GetAppealTicketDetail($id: Long!) {
        getAppealTicketDetail(id: $id) {
            id
            ticketNo
            trackingNumber
            orderId
            reason
            source
            amount
            creationTime
            appealTime
            appealDeadline
            driverName
            driverPhone
            rejectReason
            hubName
            warehouseName
            status
            statusDescription
            penaltyStatusCode
            appealDetails {
                appealCount
                appealReason
                appealTime
                evidenceImageUrls
            }
            dsp {
                id
                name
                dspCode
                contactPhone
            }
            operationLogs {
                id
                operatorName
                operatedAt
                description
            }
        }
    }
`;

export interface GetAppealTicketDetailResponse {
    getAppealTicketDetail: AppealTicketDetailType;
}
